import { Component, OnInit } from '@angular/core';
import { MessageService } from '../message.service';
import { Message } from 'src/app/shared/models/Message';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.css']
})
export class MessagesComponent implements OnInit {

  constructor(public messageService: MessageService) { }

  ngOnInit() {
  }

  close(message: Message) {
    this.messageService.close(message);
  }
}
